/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';

type OfferedByProps = {|
    sellerName: string,
|};

const OfferedBy = ({ sellerName }: OfferedByProps) => (
    <span data-tn="portfolio-row-dealer">
        <FormattedMessage
            id="dc.searchProductTile.offeredBy"
            defaultMessage={`Offered By {sellerName}`}
            values={{ sellerName }}
        />
    </span>
);

export default OfferedBy;
